import { CYC_KIND, CYC_COL, cycAng, cycArc } from '../lib/aquaCycle';

const rgb = (c) => `rgb(${c.join(',')})`;

// SVG version of the field ⇄ office cycle at the top of the AquaFlow manual
export function AquaCycle({ ui }) {
  const R = 100, r = 20;
  return (
    <figure className="aq-cycle" data-testid="aq-cycle">
      <svg viewBox="-230 -150 460 300" role="img" aria-label={ui.cycleC}>
        <defs>{Object.entries(CYC_COL).map(([k, c]) => <marker key={k} id={`cyc-${k}`} viewBox="0 0 10 10" refX="7" refY="5" markerWidth="5" markerHeight="5" orient="auto"><path d="M0,0 L10,5 L0,10 z" fill={rgb(c)} /></marker>)}</defs>
        {CYC_KIND.map((k, i) => <polyline key={`a${k}${i}`} points={cycArc(i, R, 0.26).map((p) => p.join(',')).join(' ')} fill="none" stroke={rgb(CYC_COL[k])} strokeWidth="3" markerEnd={`url(#cyc-${k})`} className="aq-cycle-arc" style={{ animationDelay: `${i * 0.12}s` }} />)}
        {CYC_KIND.map((k, i) => {
          const a = cycAng(i), x = Math.cos(a) * R, y = Math.sin(a) * R, lx = Math.cos(a) * (R + r + 8), ly = Math.sin(a) * (R + r + 8) + (Math.sin(a) > 0.5 ? 10 : Math.sin(a) < -0.5 ? -4 : 4);
          const anchor = Math.cos(a) > 0.3 ? 'start' : Math.cos(a) < -0.3 ? 'end' : 'middle';
          return (
            <g key={`s${i}`} data-testid={`aq-cycle-st-${i + 1}`}>
              <circle cx={x} cy={y} r={r} fill={rgb(CYC_COL[k])} />
              <text x={x} y={y + 6} textAnchor="middle" fontSize="18" fontWeight="700" fill="#fff">{i + 1}</text>
              <text x={lx} y={ly} textAnchor={anchor} fontSize="13" fontWeight="600" fill={rgb(CYC_COL[k])}>{ui.cycle[i]}</text>
            </g>
          );
        })}
        <text x="0" y="5" textAnchor="middle" fontSize="16" fontWeight="800" fill="#0a2540">{ui.cycleC}</text>
      </svg>
      <figcaption>{[['field', ui.cycleF], ['office', ui.cycleO], ['hand', ui.cycleH]].map(([k, l]) => <span key={k}><i style={{ background: rgb(CYC_COL[k]) }} /> {l}</span>)}</figcaption>
    </figure>
  );
}
